import { environment } from './../../environments/environment';
import { Injectable,Inject ,Optional } from '@angular/core';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Preferences } from '@capacitor/preferences';
import { AlertController } from '@ionic/angular';
import { Http,HttpOptions } from '@capacitor-community/http';
import { Observable } from 'rxjs';
import { from } from 'rxjs';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
@Injectable()
export class Service2Service {
environment=environment
home="Home";
img:any;
imgurl:any;
  constructor(public alertController:AlertController,
    private router:Router,
    private toastController:ToastController,
    ) { }

  async presenttoast(position: 'top' | 'middle' | 'bottom',msg:any) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1500,
      position: position,
    });

    await toast.present();
  }


  call_api_post(url:any,data:any) :Observable<any>{
    const options :HttpOptions= {
      url: url,
      method:"POST",
     //headers: {"Content-Type":"application/json" },
      data: data,
    };

    return from(Http.request(options));
  }
  
  logout(){
    sessionStorage.setItem(this.environment.API_URL,"");
    this.router.navigate(['/welcomepage']);   
  }

//   public async addNewToGallery() {
//   // Take a photo
//   const capturedPhoto = await Camera.getPhoto({
//     resultType: CameraResultType.Uri,
//     source: CameraSource.Camera,
//     // quality: .5,
//     // width: 800, // Maximum width for 2 megapixels
//     // height: 600, // Maximum height for 2 megapixels
//   });
//   console.log("capturedPhoto", capturedPhoto);

//   const resizedPhoto:any = await this.resizePhoto(capturedPhoto, 800, 600);
//   const savedImageFile = await this.savePicture(resizedPhoto);

//   this.imgurl = savedImageFile.filepath;
//   this.img = savedImageFile.webviewPath;
// }





async resizePhoto(photo:Photo, maxWidth:number, maxHeight:number) {
  const image:any = new Image();
  image.src = photo.webPath;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const aspectRatio = image.width / image.height;

      let newWidth = image.width;
      let newHeight = image.height;
      console.log("width", newWidth, "Height", newHeight);

      if (newWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = newWidth / aspectRatio;
      }

      if (newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = newHeight * aspectRatio;
      }

      const canvas = document.createElement('canvas');
      const context:any = canvas.getContext('2d');

      canvas.width = newWidth;
      canvas.height = newHeight;
      console.log("canWidth", canvas.width, "canHeight", canvas.height);

      context.drawImage(image, 0, 0, newWidth, newHeight);

      canvas.toBlob(
        (blob) => {
          // if (blob) {
          //   const resizedPhoto = {
          //     webPath: photo.webPath,
          //     format: photo.format,
          //     blob: blob,
          //   };
          //   // console.log("canWidth", resizedPhoto.width, "canHeight", resizedPhoto.height);
          //   console.log("resizedPhoto",resizedPhoto);
          //   resolve(resizedPhoto);
          // } 
           if (blob) {
            const blobWebPath = URL.createObjectURL(blob);
            const resizedPhoto = {
              webPath: blobWebPath,
              format: blob.type,
              blob: blob,
          };
           console.log("resizedPhoto",resizedPhoto);
           resolve(resizedPhoto);
          } else {
            reject(new Error('Unable to convert canvas to Blob'));
          }
        },
        photo.format,
        0.1
      );

     

    };

    image.onerror = (error:any) => {
      reject(error);
    };
  });
}
  


  private async savePicture(photo: Photo) {
    // Convert photo to base64 format, required by Filesystem API to save
    const base64Data = await this.readAsBase64(photo);
  
    // Write the file to the data directory
    const fileName = new Date().getTime() + '.jpeg';
    const savedFile = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Data
    });
  
    // Use webPath to display the new image instead of base64 since it's
    // already loaded into memory
    return {
      filepath: fileName,
      webviewPath: photo.webPath
    };
  }



  private async readAsBase64(photo: any) {
    // Fetch the photo, read as a blob, then convert to base64 format
    const response = await fetch(photo.webPath!);
    const blob = await response.blob();
    // const blob = photo.blob
    
  
    return await this.convertBlobToBase64(blob) as string;
  }
  
  private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
        resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });



  // For alert 
 async presentAlert(input_msg: any, callback?: () => void) {
  const alert = await this.alertController.create({
    cssClass: 'my-custom-class',
    message: input_msg,
    buttons: ['OK']
  });

  await alert.present();

  const { role } = await alert.onDidDismiss();
  console.log('onDidDismiss resolved with role', role);

  // Run focus or any follow-up logic
  if (callback) {
    setTimeout(() => {
      callback();
    }, 50); // Small delay ensures DOM is ready
  }
}


  
}
